import { FunctionComponent } from 'react';
import styled from '@emotion/styled';
import colors from '@app/styles/theme/colors';
import { rem } from '@app/styles/theme/layout';

export const Select = styled.select`
  font-size: ${rem(16)};
  height: ${rem(34)};
  padding: 0 ${rem(12)};
  border-color: ${colors.gray};
  border-radius: ${rem(3)};

  &:focus {
    border-color: ${colors.darkGray};
  }
`;

interface Option {
  key: number | string;
  value: string | number;
  label?: string;
}

const Dropdown: FunctionComponent<{
  value: string | number;
  onChange: (value: string | number) => void;
  options: Array<Option>;
  disabled?: boolean;
  ['data-testid']?: string;
}> = ({ onChange, options, ...props }) => {
  return (
    <Select {...props} onChange={({ target }) => onChange(target.value)}>
      {options.map(({ key, value, label }) => (
        <option key={key} value={value}>
          {label ?? value}
        </option>
      ))}
    </Select>
  );
};

export default Dropdown;
